import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import styled from "styled-components";
import { motion, useAnimation, useInView } from "framer-motion";
import { getAuth, updateProfile } from "firebase/auth"; // Import updateProfile

const SignUp = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState(""); // New state for the name
  const [error, setError] = useState("");
  const { signup } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    document.title = "Signup | Premium Perfume KS";
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError("");
      const auth = getAuth(); // Get the auth instance
      const userCredential = await signup(email, password); // Create the user
      const user = userCredential.user;

      // Update the user's displayName
      await updateProfile(user, { displayName: name });
      console.log("Display name updated to:", name);

      navigate("/account");
    } catch (err) {
      console.error("Error creating account:", err);
      setError("Failed to create an account");
    }
  };

  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const animation = useAnimation();

  useEffect(() => {
    if (isInView) {
      animation.start("visible");
    }
  }, [isInView, animation]);

  return (
    <Container>
      <motion.h1
        ref={ref}
        variants={{
          hidden: { opacity: 0, y: 100, scale: 0.6 },
          visible: { opacity: 1, y: 0, scale: 1 },
        }}
        initial="hidden"
        animate={animation}
        transition={{ duration: 0.4, delay: 0.3, type: "spring" }}
      >
        Sign Up
      </motion.h1>
      {error && <p>{error}</p>}
      <motion.form
        onSubmit={handleSubmit}
        variants={{
          hidden: { opacity: 0, y: 100, scale: 0.6 },
          visible: { opacity: 1, y: 0, scale: 1 },
        }}
        initial="hidden"
        animate={animation}
        transition={{ duration: 0.4, delay: 0.3, type: "spring" }}
      >
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Name"
          required
        />
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          required
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          required
        />
        <button type="submit">Regjistrohu</button>
        <p>
          Keni llogari të hapur?{" "}
          <Link className="link" to={"/login"}>
            Kyqu
          </Link>
        </p>
      </motion.form>
    </Container>
  );
};

const Container = styled.div`
  text-align: center;
  margin-top: 2%;
  padding: 5em 7%;
  .error {
    color: red;
    padding: 1em;
  }
  h1 {
    font-family: "Comfortaa";
    font-size: 2.8em;
    margin-bottom: 10px;
  }
  form {
    margin: auto;
    background-color: #303030;
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding: 40px 30px;
    width: 400px;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    input {
      width: 100%;
      background: none;
      color: white;
      font-size: 18px;
      font-family: "Comfortaa";
      border: 1px solid white;
      border-radius: 20px;
      padding: 14px 14px;
      outline: none;
    }
    button {
      background: white;
      font-family: "Comfortaa", sans-serif;
      padding: 12px 20px;
      border: none;
      border-radius: 30px;
      font-size: 19px;
      margin-top: 5px;
      cursor: pointer;
      transition: 0.4s;
      &:hover {
        background: var(--primaryColor);
        color: white;
      }
    }
    p {
      margin-top: 1em;
      .link {
        color: white;
      }
    }
  }
  @media (max-width: 550px) {
    padding: 7em 5%;
    h1 {
      font-size: 8vw;
    }
    form {
      width: 100%;
    }
  }
`;

export default SignUp;
